import DayjsUtils from '@date-io/dayjs'
import {
	Divider,
	makeStyles, Table,
	TableBody,
	TableCell,
	TableHead,
	Box,
	Container,
	TablePagination,
	TableRow,
} from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Radio from '@material-ui/core/Radio'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import TableContainer from "@material-ui/core/TableContainer"
import Tooltip from '@material-ui/core/Tooltip'
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import * as dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useSnackbar } from 'notistack';
import { useActions, useValues } from 'kea';

import assetlogic from 'src/store/asset'
import { rbeaconmovementlogic } from 'src/store/report'
import { minHistoryDate } from 'src/utils/constants';


const useStyles = makeStyles({
	root: {
		width: "100%"
	},
	container: {
		maxHeight: '440'
	}
});

let columns = [
	{
		field: 'type',
		headerName: 'Type',
		align: 'left',
		width: 200,
	},
	{
		field: 'name',
		headerName: 'Name',
		align: 'left',
		width: 200,
	},
	{
		field: 'info',
		headerName: 'Information',
		align: 'left',
		width: 250,
	},
	{
		field: 'actions',
		align: 'left',
		headerName: 'Actions',
		width: 150,
	},
];

const initialTemperatureDataParam = {
	asset: '',
	start: dayjs().startOf('day'),
	stop: dayjs().endOf('day')
}

const TemperatureDataDialog = () => {
	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();

	const { assets } = useValues(assetlogic);
	const { fetchAll: assetFetchAll } = useActions(assetlogic);

	const { fetch } = useActions(rbeaconmovementlogic);

	const [TemperatureDataParam, setTemperatureDataParam] = useState(initialTemperatureDataParam);
	const [open, setOpen] = React.useState(false);
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);


	useEffect(() => {
		assets ?? assetFetchAll();
	}, []) // eslint-disable-line


	if (assets === null) {
		return (
			<></>
		)
	}
	const emptyRows = rowsPerPage - Math.min(rowsPerPage, assets.length - page * rowsPerPage);

	const handleChangePage = (even, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};


	const handleClickOpen = () => {
		setOpen(true);
	}

	const handleClose = () => {
		setOpen(false);
	}

	const handleAdd = () => {
		if (!TemperatureDataParam.asset) {
			enqueueSnackbar('Please Select an Asset', { variant: 'error' });
			return
		}
		if (dayjs(TemperatureDataParam.start).isAfter(TemperatureDataParam.stop)) {
			enqueueSnackbar('Please enter correct dates', { variant: 'error' });
			return
		}
		addDataHandler(TemperatureDataParam);
		setTemperatureDataParam(initialTemperatureDataParam);
		handleClose();
	}

	const handleChange = (key, value) => {
		let updatedParams = { ...TemperatureDataParam };
		updatedParams[key] = value;
		setTemperatureDataParam(updatedParams);
	}

	const handleHotKey = (period, value, lastdays = true) => {
		let updatedParams = { ...TemperatureDataParam };
		if (period === 'month') {
			updatedParams.start = dayjs().subtract(value, 'month').startOf('month');
			updatedParams.stop = dayjs().subtract(value, 'month').endOf('month');
		} else if (period === 'week') {
			updatedParams.start = dayjs().subtract(value, 'week').startOf('week');
			updatedParams.stop = dayjs().subtract(value, 'week').endOf('week');
		} else if (period === 'day') {
			updatedParams.start = dayjs().subtract(value, 'day').startOf('day');
			updatedParams.stop = lastdays ? dayjs().subtract(value, 'day').endOf('day') : dayjs().endOf('day');
		}
		setTemperatureDataParam(updatedParams);
	}

	const addDataHandler = (new_data) => {
		fetch(new_data);
	}

	return (
		<div style={{ paddingTop: '15px' }}>
			<Tooltip title="Generate Report">
				{/* <IconButton aria-label="add" onClick={handleClickOpen}>
					<AddIcon />
				</IconButton> */}
				<Button
					color="primary"
					variant="contained"
					aria-label="add"
					onClick={handleClickOpen}
				>
					Generate Report
				</Button>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
				maxWidth='xl'
			>
				<DialogTitle id="form-dialog-title">Generate Report</DialogTitle>
				<DialogContent>
					{/* <DialogContentText>Add Vehicle</DialogContentText> */}

					<div style={{ height: '100%', width: '100%', background: 'white' }}>
						<TableContainer className={classes.container}>
							<Table stickyHeader aria-label="sticky table" size={'small'}>
								<TableHead>
									<TableRow>
										{columns.map((column) => (
											<TableCell
												key={column.field}
												align={column.align}
												style={{ minWidth: column.width }}
											>
												{column.headerName}
											</TableCell>
										))}
									</TableRow>
								</TableHead>
								<TableBody>
									{
										assets && assets.length > 0 ?
											assets
												.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
												.map((row) => {
													if (!row.beacon) return null;
													return (
														<TableRow hover role="checkbox" tabIndex={-1} key={row._id}>
															{columns.map((column) => {
																if (column.field === 'enabled') {
																	return (
																		<TableCell key={column.field} align={column.align}>
																			{
																				row[column.field] ?
																					'Enabled'
																					:
																					'Disabled'
																			}
																		</TableCell>
																	)
																}
																if (column.field === 'actions') {
																	return (
																		<>
																			<TableCell key={column.field} align={column.align}>
																				<Radio
																					color="primary"
																					inputProps={{ 'aria-label': 'secondary checkbox' }}
																					checked={TemperatureDataParam.asset === row._id}
																					onChange={() => handleChange('asset', row._id)}
																				/>
																			</TableCell>
																		</>
																	)
																}
																if (column.field === 'info') {
																	return (
																		<>
																			<TableCell key={column.field} align={column.align}>
																				{`${row.year} ${row.company} ${row.model} ${row.color}`}
																			</TableCell>
																		</>
																	)
																}
																const value = row[column.field];
																return (
																	<TableCell key={column.field} align={column.align}>
																		{column.format && typeof value === "number"
																			? column.format(value)
																			: value}
																	</TableCell>
																);
															})}
														</TableRow>
													);
												})
											: <TableRow>
												<TableCell style={{ height: 61 * rowsPerPage }} colSpan={5} align={'center'}>
													No Data Added.
												</TableCell>
											</TableRow>
									}
									{
										assets.length > 0 && emptyRows > 0 && (
											<TableRow style={{ height: 61 * emptyRows }}>
												<TableCell colSpan={6} />
											</TableRow>
										)
									}
								</TableBody>
							</Table>
						</TableContainer>
						{/* </Paper> */}
					</div>
				</DialogContent>
				<DialogActions>
					{/* <Tooltip title="Add multiple">
						<Switch
							checked={switchState.addMultiple}
							onChange={handleSwitchChange('addMultiple')}
							value="addMultiple"
							inputProps={{ 'aria-label': 'secondary checkbox' }}
						/>
					</Tooltip> */}
					<Container maxWidth={false}>
						<Box>
							<TablePagination
								rowsPerPageOptions={[10, 15, 20]}
								component="div"
								count={assets ? assets.length : 0}
								rowsPerPage={rowsPerPage}
								page={page}
								onChangePage={handleChangePage}
								onChangeRowsPerPage={handleChangeRowsPerPage}
							/>
							<Divider />
						</Box>
						<Box>
							<div style={{ paddingTop: '15px', paddingBottom: '15px', width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
								<div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start' }}>
									<Button onClick={() => handleHotKey('day', 30, false)} color="primary">
										Last 30 Days
									</Button>
									<Button onClick={() => handleHotKey('month', 1)} color="primary">
										Last Month
									</Button>
									<Button onClick={() => handleHotKey('week', 1)} color="primary">
										Last Week
									</Button>
									<Button onClick={() => handleHotKey('day', 1)} color="primary">
										Last Day
									</Button>
								</div>
								<div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
									<div style={{ minWidth: '50px' }} >
										<MuiPickersUtilsProvider utils={DayjsUtils}>
											<DateTimePicker
												autoOk
												ampm={false}
												variant="inline"
												label="Start"
												minDate={minHistoryDate}
												value={TemperatureDataParam.start}
												onChange={(value) => handleChange('start', value)}
												disableFuture
											/>
										</MuiPickersUtilsProvider>
									</div>
									<div style={{ minWidth: '50px' }} />
									<MuiPickersUtilsProvider utils={DayjsUtils}>
										<DateTimePicker
											autoOk
											ampm={false}
											variant="inline"
											label="Stop"
											value={TemperatureDataParam.stop}
											onChange={(value) => handleChange('stop', value)}
											disableFuture
											minDate={TemperatureDataParam.start}
											minDateMessage={'Date should not be before \'Start date\''}
										/>
									</MuiPickersUtilsProvider>
								</div>
							</div>
							<Divider />
						</Box>
						<Box>
							<div style={{ paddingTop: '15px', paddingBottom: '15px', width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
								<Button onClick={handleClose} color="primary">
									Cancel
								</Button>
								<Button onClick={handleAdd} color="primary">
									Generate
								</Button>
							</div>
						</Box>
					</Container>
				</DialogActions>
			</Dialog >
		</div >
	)
}

TemperatureDataDialog.propTypes = {
}

export default TemperatureDataDialog
